<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{op=='add'?'新增二级分类':'修改二级分类'}}</myNav>
            <div class="sn-info-box">
                <el-row>
                    <el-col :span="12">
                        一级分类{{$t('x_mh')}}<span class="f-blue">{{cat_cname}}</span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" :rules="rule" label-width="120px">
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('cname')" prop="cat_cname">
                        <el-input v-model="formData.cat_cname" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item :label="$t('sort')" prop="sort_id">
                        <el-input v-model="formData.sort_id" :placeholder="$t('input')"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item :label="$t('status')" prop="cat_status" v-show="op == 'upd'">
                        <el-radio-group v-model="formData.cat_status">
                            <el-radio v-for="item in cat_status" :key="item.key" :label="item.key">{{item.value}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
export default {
    components:{
    },
    data:function(){
        return{
            op: this.$base.getRequest().op,
            formData: {
                cat_id: "",
                cat_id2: "",
                sort_id: "99",
                cat_cname : '',
                cat_status:'1'
            },
            rule: {
                sort_id: [{required: true, pattern:this.$base.regNum(), message: this.$t('input'), trigger: 'blur'}],
                cat_cname: [{required: true, message: this.$t('input'), trigger: 'blur'}],
            },
            cat_cname:'',
            cat_status:[],
        }
    },
    computed:{
    },
    mounted: function(){
        this.$parent.$parent.show_subview = true;
        var info = this.$base.getRequest();
        this.formData.cat_id = info.cat_id;
        this.cat_cname = info.cat_cname;
        this.formData.cat_id2 = info.cat_id2;
        if(this.op == 'upd'){
            this.getInfo();
        }
    },
    methods:{
        cancel: function(){
            this.$base.linkBack();
        },
        getInfo: function(){
            if(!this.formData.cat_id2){
                return;
            }
            var data = {
                cat_id2: this.formData.cat_id2
            };
            this.$base.showLoading();
            this.$request.sendPost("base-goodscat2/before-upd",data,(success,data,error)=>{
                this.$base.hideLoading();
                if(success){
                    this.formData = this.$base.leftJson(this.formData,data.info);
                    this.cat_status = data.cat_status;
                }
                else{
                    this.$base.alertErr(error.errmsg);
                }
            });
        },
        submit: function(){
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    var url = this.op == 'upd' ? "base-goodscat2/upd" : "base-goodscat2/add";
                    this.$base.showLoading();
                    this.$request.sendPost(url,this.formData,(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.$base.msgSuccess(error.errmsg);
                            this.relist = true;
                            this.$base.linkBack();
                        }
                        else{
                            this.$base.alertErr(error.errmsg);
                        }
                    });
                } else {
                    this.$base.alertErr(this.$t('incomplete'));
                }
            })
        }
    },
    beforeDestroy: function () {
        this.$parent.$parent.show_subview = false;
        this.$parent.$parent.relist = this.relist;
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/base/goodscat/save2.vue